<template>
  <div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Товар</th>
          <th>{{$t('Нарх')}} <input type="checkbox" v-model="price"></th>
          <th>{{$t('Cони')}}
            <button style="float: right;" type="button" class="btn btn-primary" @click='Print()'>
              <b-icon icon="printer"></b-icon>
            </button>
            <button style="float: right;" type="button" class="btn btn-success" @click='Clear()'>
              {{$t('Тозалаш')}}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in datas.transfer_table" :key="index">
          <td>
            {{item.product.extra_name}}
          </td>
          <td>
            {{item.chakana_price}}
          </td>
          <td>
            <input type="number" @input="item.count=parseInt(item.count)" v-model="item.count">
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mybody" style="display: none;">
      <span v-for="(item, index) in datas.transfer_table" :key="index">
        <div v-if="item.shtrix_kod!=''" v-for="n in item.count">
          <div class="page" v-if="price!=true">
            <center style="height: 15vh;">{{item.product.extra_name}}</center>
            <barcode width="3" height="110px" :value="item.shtrix_kod"></barcode>
            <center v-if="price==true">{{item.chakana_price|numFormat}} cўм</center>
          </div>
          <div class="page price" v-else>
            <center style="height: 28vh;">{{item.product.extra_name}}</center>
            <div style="height: 15vh!important;">
              <div style="text-align: center;width: 150%!important;">
                <div class="pricebarcode">
                  <b class="pricetext">{{item.chakana_price|numFormat0}}</b>
                  <div style="width: 80px !important;display: block;">
                    <!-- <p>{{item.chakana_price|numFormat0}}</p> -->
                    <!-- <hr class="hr"> -->
                    <p>cўм</p>
                  </div>
                </div>
              </div>
            </div>
            <barcode width="2" height="48px" :value="item.shtrix_kod"></barcode>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>
<style>
  .vue-barcode-element {
    width: 140% !important;
    height: 54vh;
  }

  .pricebarcode p {
    text-align: center;
  }

  .pricebarcode {
    display: inline-flex;
    /* width: 150%!important; */
  }

  .price .vue-barcode-element {
    width: 150% !important;
    height: 28vh;
  }

  .price p {
    font-size: 50pt;
  }

  .mybody {
    /* margin: -40% 0!important; */
  }

  .page center {
    /* zoom: 1; */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1;
    font-weight: bold;
    width: 145% !important;
    /* height: 30vh; */
    font-size: 100pt !important;
  }

  .pricetext {
    text-align: center !important;
    /* width: 75%; */
    line-height: 1;
    font-weight: 100;
    font-size: 180pt !important;
  }

  .page {
    page-break-after: always;
    page-break-inside: avoid;
    padding: 0 !important;
    /* width: 145%!important; */
    /* width: 1000px; */
    transform: rotate(90deg);
  }

  .page.price>center {
    font-size: 70pt !important;
  }

  .vue-barcode-element text {
    text-align: center;
    font-size: 20pt !important;
  }
</style>
<script>
  import $ from "jquery";
  import VueBarcode from 'vue-barcode';
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  export default {
    name: "Print",
    components: { 'barcode': VueBarcode },
    data() {
      return {
        price: true,
        datas: [],
        mysklad: [],
        rotateType: 0,
        options: {
          offsetX: 0,
          offsetY: 0,
          imageWidth: 300
        },
        qarz: 0
      };
    },
    created: function () {
      this.Data();
    },
    mounted: function () {
    },
    methods: {
      Print() {
        var head = $(".mybody").html();
        if (head == undefined) {
          head = "";
        }
        window.document.body.innerHTML = head;
        window.print();
        window.location.reload();
      },
      Clear() {
        let self = this;
        self.datas.transfer_table.forEach(function (key, value) {
          key.count = 0;
        });
      },
      Data() {
        let self = this;
        axios
          .get("api/v1/transfer/id/" + self.$route.params.id)
          .then(function (response) {
            self.datas = response.data;
          });
      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Ostatka(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    }
  };
</script>